export const customerTypeInfoTooltip = `This customer's ACH payment methods will show on each receivable page`;
